// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3dAJO","calendarButtons":"ClockData_calendarButtons__DdLRU"};